<template>
  <section>
    <b-col
      v-if="isInitialLoad"
      class="px-0"
    >
      <b-skeleton
        animation="wave"
        class="mx-auto"
        width="736px"
        height="138px"
      />
    </b-col>
    <section v-else>
      <b-container class="container-736px">
        <b-card class="mt-2">
          <b-row>
            <b-col
              :cols="selectedUrl ? 11 : 12"
            >
              <b-form-group
                :label="$tk('ClientPortal.MasterTable.Ad')"
              >
                <multiselect
                  v-model="selectedVal"
                  :options="ads.ads"
                  :close-on-select="true"
                  label="name"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                  :internal-search="false"
                  :search="searchTerm"
                  :preserve-search="true"
                  @select="selectedOption => setOption(selectedOption)"
                  @remove="deselectOption"
                  @search-change="handleSearchChange"
                >
                  <template slot="placeholder">
                    <span class="multiselect__placeholder mb-0">{{ $tk('Admin.RenderDebugger.SelectAd') }}</span>
                  </template>
                  <template
                    slot="option"
                    slot-scope="props"
                  >
                    <div class="option__desc">
                      <span class="option__title">
                        {{ props.option.name }}
                      </span>
                    </div>
                  </template>
                  <template
                    slot="caret"
                    slot-scope="{ toggle }"
                  >
                    <div
                      class="multiselect__select"
                      @mousedown.prevent.stop="toggle()"
                    >
                      <GjIcon
                        class="icon-wrapper"
                        name="ArrowDown_fill"
                        size="21"
                      />
                    </div>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col
              class="copy-link__btn"
              cols="1"
            >
              <b-button
                v-if="selectedUrl"
                variant="link-secondary"
                size="sm"
                @click="copyLink"
              >
                <GjIcon
                  name="Copy"
                />
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
      <b-container
        v-if="selectedUrl"
        :class="isVast ? 'container-736px' : ''"
      >
        <b-card
          v-if="!isVast"
          class="mr-1"
        >
          <iframe
            :src="selectedUrl"
            scrolling="auto"
            width="100%"
            height="500px"
          />
        </b-card>
        <b-card
          v-else
          class="url-card pr-1"
        >
          <span
            class="mb-1"
          >{{ $tk('Admin.RenderDebugger.RenderedAdWithVast') }}
            <GjIcon
              name="Info"
            />
          </span>
          <b-button
            variant="outline-primary"
            :href="selectedUrl"
            target="_blank"
            class="render-ad_btn"
          >
            <GjIcon
              name="Hyperlink"
            />
            <span>{{ $tk('Admin.RenderDebugger.ClickBelowToSeeRenderedAd') }}</span>
          </b-button>
        </b-card>
      </b-container>
    </section>
  </section>
</template>

<script>
import store from '@/store'
import Multiselect from 'vue-multiselect'
import {
  computed,
  ref,
  onMounted,
} from '@vue/composition-api'
import RenderDebuggerService from '@/api/admin/renderDebugger.service'
import notification from '@/mixins/toastification'
import translation from '@/mixins/translate'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    Multiselect,
    GjIcon,
  },
  mixins: [notification],
  setup() {
    const ads = computed(() => store.getters.getAds)
    const isLoading = ref(true)
    const selectedVal = ref(null)
    const selectedUrl = ref(null)
    const isVast = ref(false)
    const searchTerm = ref('')

    const isInitialLoad = ref(true)

    const debounce = (func, delay) => {
      let debounceTimer
      return function debouncedFunction(...args) {
        const context = this
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
      }
    }

    const fetchAds = async (newSearchTerm, isInitial = false) => {
      if (isInitial) isLoading.value = true
      await store.dispatch('getRenderAds', newSearchTerm)
      if (isInitial) isLoading.value = false
      isInitialLoad.value = false
    }

    const handleSearchChange = debounce(newSearchTerm => {
      if (newSearchTerm !== searchTerm.value) {
        searchTerm.value = newSearchTerm
        fetchAds(newSearchTerm)
      }
    }, 500)

    onMounted(async () => {
      fetchAds('', true)
    })
    const renderUrl = async () => {
      try {
        const response = await RenderDebuggerService.generateRenderUrl(selectedVal.value.id)
        if (response) {
          selectedUrl.value = response
          if (response.includes('rendervast')) {
            isVast.value = true
          } else {
            isVast.value = false
          }
        }
      } catch (err) {
        notification.methods.error(err.message)
      }
    }
    const setOption = option => {
      selectedVal.value = option
      selectedUrl.value = null
      renderUrl()
    }
    const deselectOption = () => {
      selectedUrl.value = null
      selectedVal.value = null
    }
    const copyLink = () => {
      const { clipboard } = navigator
      clipboard.writeText(selectedUrl.value)
      notification.methods.success(translation.methods.$tk('Admin.RenderDebugger.LinkCopied'))
    }
    return {
      ads,
      selectedUrl,
      isLoading,
      selectedVal,
      setOption,
      deselectOption,
      copyLink,
      isVast,
      searchTerm,
      handleSearchChange,
      isInitialLoad,
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/views/admin/ad-debugger/render-debugger.scss';
</style>
<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
